module.exports = __webpack_public_path__ + "img/image 005.e242d95c.png";